import { Card, CardBorderRadius, CardBorderStyle, CardHeaderTheme, CardTheme } from '@apply/components';
import { BorrowerEntity } from '../../../../queries/borrowerEntityQueries';
import { BorrowerEntityHeader } from './components/BorrowerEntityHeader';
import { BorrowerEntityAddress } from './components/BorrowerEntityAddress';
import { BorrowerEntityTin } from './components/BorrowerEntityTin';
import { EntityPrincipalsTable } from './components/EntityPrincipalsTable';
import { hasEntityAddress } from './functions/hasEntityAddress';
import '../../../../styles/_detailCard.scss';

interface BorrowerEntityCardProps {
    entity: BorrowerEntity;
    /** Omit to leave out the edit button. */
    onEdit?: () => void;
}

/** The selected entity's address and TIN side by side, then its principals, with a button to edit it. */
export const BorrowerEntityCard = ({ entity, onEdit }: BorrowerEntityCardProps) => {
    return (
        <Card
            header={
                <BorrowerEntityHeader
                    name={entity.name}
                    onEdit={onEdit}
                />
            }
            headerTheme={CardHeaderTheme.Blue}
            theme={CardTheme.White}
            borderStyle={CardBorderStyle.Solid}
            borderRadius={CardBorderRadius.Small}
            width='100%'
        >
            <div className='borrowerSelectorCardSections'>
                {/* Skipped when there's neither, so it doesn't leave a gap above the principals */}
                {(hasEntityAddress(entity) || entity.tin) && (
                    <div className='borrowerSelectorCardColumns'>
                        <div>
                            <BorrowerEntityAddress entity={entity} />
                        </div>
                        <div>
                            <BorrowerEntityTin tin={entity.tin} />
                        </div>
                    </div>
                )}
                <EntityPrincipalsTable principals={entity.principals ?? []} />
            </div>
        </Card>
    );
};
